import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import useMobileLayout from '@/hooks/use-mobile-layout';
type ReadModeOptions = {
  isRestoring: boolean;
  /** Editing belongs to one document, so opening another ends it. */
  documentId: string | null;
  /** Opens read-only on every screen, for a document whose read view differs from its editor. */
  readFirst?: boolean;
};

// Phones open documents read-only: a tap on the editor focuses its contenteditable and raises the
// keyboard, so reading, selecting text or opening a citation would otherwise start an edit.
const useReadMode = t0 => {
  const $ = _c(9);
  const {
    isRestoring,
    documentId,
    readFirst: t1
  } = t0;
  const readFirst = t1 === undefined ? false : t1;
  const isMobile = useMobileLayout();
  const [editingId, setEditingId] = useState(null);
  const isEditing = documentId !== null && editingId === documentId;
  const opensReadOnly = isMobile || readFirst;
  const isReadOnly = opensReadOnly && !isEditing;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setEditingId(null);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const stopEditing = t2;
  const t3 = !isRestoring && !isReadOnly;
  let t4;
  if ($[1] !== documentId || $[2] !== isReadOnly) {
    t4 = isReadOnly ? () => setEditingId(documentId) : undefined;
    $[1] = documentId;
    $[2] = isReadOnly;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = opensReadOnly && isEditing ? stopEditing : undefined;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = id => setEditingId(id);
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t7 = {
      isEditable: t3,
      onStartEditing: t4,
      onStopEditing: t5,
      startEditing: t6,
      stopEditing
    };
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default useReadMode;